import "../../../../libs/backbone/backbone.ajaxq.adapter.ts";

import Handlebars from 'handlebars';
import Template from 'text-loader!../../../templates/analytics/datepicker/analytics_datepicker.template.html';

import i18n  from "l10n";

export default Backbone.View.extend({
    el: "#dates-selector",
    tagName: 'div',
    className: '',
    template: Handlebars.compile(Template),
	from: null,
    to: null,
    initialize: function (options) {
        var self = this;

        this.from = options && options.from ? $.datepicker.formatDate('yy-mm-dd', new Date(options.from)) : $.datepicker.formatDate('yy-mm-dd', new Date());
        this.to = options && options.to ? $.datepicker.formatDate('yy-mm-dd', new Date(options.to)) : $.datepicker.formatDate('yy-mm-dd', new Date());
	},
	superRender: Backbone.View.prototype.render,
	render: function () {
		var self = this;
		this.superRender();

        var templateParams = $.extend({}, this.venueId, {"lang": i18n.lng()});
        var templateData = this.template( templateParams );

		this.$el.html( templateData );

        this.initializeDatePicker();

        return this;
	},
	events:{
        "change input.date" : "validateDates",
        "click .dateInputInfo": "showDate",
	},
	showDate: function(e) {
        var $elem = $(e.currentTarget);
        $elem.next().focus();
    },
    initializeDatePicker: function() {
        var self = this;

        $.datepicker.setDefaults( $.datepicker.regional[ i18n.lng() ] );

        var datepickerOptions = {
            //"yearRange": (yearFrom +":"+ yearTo),
            "dateFormat": "yy-mm-dd",
             maxDate: '+0d'
        };

        var starting = this.$el.find('#startingDate');
        starting.datepicker(datepickerOptions);
        starting.val(this.from);

        var ending = this.$el.find('#endingDate');
        ending.datepicker(datepickerOptions);
        ending.val(this.to);
    },
    getDates: function() {
        var inputFrom = this.$el.find("#startingDate");
        var inputTo = this.$el.find("#endingDate");

        var dateFrom = new Date(inputFrom.val());
        var dateTo = new Date(inputTo.val());


        var validDates = true;

        if(dateFrom instanceof Date && !isNaN(dateFrom))
            inputFrom.removeClass("error");
        else
        {
            validDates = false;
            inputFrom.addClass("error");
        }

        if(dateTo instanceof Date && !isNaN(dateTo))
            inputTo.removeClass("error");
        else
        {
            validDates = false;
            inputTo.addClass("error");
        }

        if(!validDates)
        {
            $.notify(i18n.t("analytics.invalid_date"), { position:"top center", className: "error" });
            return;
        }

        if(dateFrom > dateTo)
        {
            $.notify(i18n.t("analytics.less_than"), { position:"top center", className: "error" });
            inputTo.addClass("error");
            return;
        }

        this.from = inputFrom.val();
        this.to = inputTo.val();

        return {
            "from": this.from,
            "to": this.to
        };
    },
    validateDates: function(event) {
        var element = $(event.currentTarget);
        var date = new Date(element.val());

        if(date instanceof Date && !isNaN(date))
            element.removeClass("error");
        else
        {
            element.addClass("error");
        }
    }
});


